<div #printContent id="printContent">
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  @if (showSchoolFilter) {
    <div class="print-hide">
      <wf-school-teacher-filter
        [error]="schoolFilterError"
        [districts]="districts"
        [schools]="schools"
        [teachers]="teachers"
        (filterChangeEvent)="filterSchoolTeacher()">
      </wf-school-teacher-filter>
    </div>
  }
  <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
    </h3>
    <div class="print-hide filter-options">
      <wf-students-filter
        [grades]="grades"
        [classes]="classes"
        [filterExtraSupport]="true"
        (filterChangeEvent)="filterSessions($event)">
      </wf-students-filter>
      <div class="zone-filter">
        <label class="bold">Zone</label>
        <select class="form-select" [(ngModel)]="selectedZone" (change)="filterSessionsByZone()">
          <option value="all">All Zones</option>
          <option value="1">Zone 1</option>
          <option value="2">Zone 2</option>
          <option value="3">Zone 3</option>
          <option value="4">Zone 4</option>
          <option value="no-data">No Zone Data</option>
        </select>
      </div>
    </div>
  </div>
  <div class="district-report-header margin-bottom-5">
    <div class="district-report-header-group gap-3">
      <span class="report">Group Report: </span>
      <div class="print-hide flex">
        <input type="radio" value="usage" id="usage-group-report" [(ngModel)]="reportType" (change)="setReportType()" />
        <label for="usage-group-report" style="margin-left: 5px;">Usage and Progress</label>
      </div>
      <div class="print-hide flex">
        <input type="radio" value="engagement" id="engagement-group-report" [(ngModel)]="reportType" (change)="setReportType()" />
        <label for="engagement-group-report" style="margin-left: 5px;">Engagement</label>
      </div>
      <div class="print-show" style="text-transform: capitalize;">{{ reportTypeDisplay }}</div>
      <div class="print-hide flex" id="show-teacher-wrapper">
        <input type="checkbox" id="show-teacher-column" [(ngModel)]="showTeacherColumn" />
        <label for="show-teacher-column" style="margin-left: 5px;">Show Teacher Column</label>
      </div>
      @if (this.showCoTeacherFilter) {
        <div class="print-hide flex" id="show-shared-wrapper">
          <input type="checkbox" id="hide-shared-students" [(ngModel)]="hideSharedStudents" (change)="toggleSharedStudents()" />
          <label for="hide-shared-students" style="margin-left: 5px;">Hide Shared Students</label>
        </div>
      }
    </div>
    <div class="flex align-items-end gap-2 report-header-buttons">
      <refresh-button (click)="refreshTableContent()"></refresh-button>
      <button id="export-button" class="btn export-report-button print-hide" (click)="exportGroupSummary()" [disabled]="exportingReport">
        @if (!exportingReport) {
          <fa-icon [icon]="excelIcon"></fa-icon>
        }
        @if (exportingReport) {
          <fa-icon [icon]="loadingIcon" [spin]="true"></fa-icon>
        }
        Export Results
      </button>
      @if (!currentUser!.isTeacherReviewUser()) {
        <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()">
          <fa-icon [icon]="printIcon"></fa-icon> Print Results
        </button>
      }
    </div>
  </div>
  <div>
    <div class="report-section-header">
      <h5 class="results-report-header">
        <fa-icon [classes]="['print-hide']" [icon]="summaryIcon"></fa-icon>
        Group Summary
      </h5>
    </div>
  </div>
  <div class="boxed-content">
    @if (reportError) {
      <div class="print-hide alert message alert-danger" id="export-error">
        <div class="icon">
          <fa-icon [icon]="errorIcon"></fa-icon>
        </div>
        <div>
          <div class="bold">Report Export Error</div>
          {{ reportError }}
        </div>
      </div>
    }
    <table class="report-table">
      <thead>
        <tr>
          @for (column of selectedColumns; track column) {
            @if (!(column['property'] === 'student.teacher' && !showTeacherColumn)) {
              <th>
                <div class="sortable-report-table-header">
                  <button
                    (click)="sortTable(column['property'])"
                  >
                    {{ column['title'] }}
                    <div
                      [ngClass]="{ 'arrow-up': !sortReverse, 'arrow-down': sortReverse }"
                      [style.visibility]="(sortColumn !== column['property']) ? 'hidden' : 'visible'"
                    >
                    </div>
                  </button>
                  @if (column['title'] === 'Previous Week Usage (min)' || column['title'] === 'Previous Week Levels Completed') {
                    <wf-tooltip>
                      WordFlight recommends students complete 60-80 minutes of practice and 6-8 levels per week.
                    </wf-tooltip>
                  }
                </div>
              </th>
            }
          }
        </tr>
      </thead>
      <tbody>
        @for (session of filteredSessions; track session) {
          <tr>
            @if (reportType === 'usage') {
              <td>{{ session.student.firstName }} {{ session.student.lastName }}</td>
              <td>{{ session.student.grade | displayGrade }}</td>
              @if (showTeacherColumn) {
                <td>
                  {{ session.student.teacher }}
                </td>
              }
              <td>{{ formatDate(session.startDate) }}</td>
              <td>{{ formatDate(session.lastUsageDate) }}</td>
              <td>
                <div>{{ getUnitStatus(session) }}</div>
              </td>
              <td>{{ (session.currentLevel === 0) ? '&mdash;' : (((session.currentLevel / 120 * 100) | number : '1.0-0') + '%') }}</td>
              <td>{{ getZoneDisplay(session) }}</td>
              <td>{{ (session.avgWeeklyUsage > 0) ? (session.avgWeeklyUsage | number:'1.0-0') : "0" }}</td>
              <td>
                @let displayValue = getDisplayValue(session, (session.prevUsageRangeTotalTime > 0) ? (session.prevUsageRangeTotalTime | number:'1.0-0') : "0");
                @if (displayValue === '—') {
                  {{ displayValue }}
                } @else {
                  <wf-color-category [level]="session.prevUsageRangeTotalTime | previousWeekUsageCategory">
                    {{ displayValue }}
                  </wf-color-category>
                }
              </td>
              <td>{{ getDisplayValue(session, (session.usageRangeTotalTime > 0) ? (session.usageRangeTotalTime | number:'1.0-0') : "0") }}</td>
            } @else {
              <td>{{ session.student.firstName }} {{ session.student.lastName }}</td>
              <td>{{ session.student.grade | displayGrade }}</td>
              <td>{{ session.student.currentTeam }}</td>
              <td>{{ (session.totalPoints > 0) ? (session.totalPoints | number:'1.0-0') : "0" }}</td>
              <td>{{ (session.previousWeeksPoints > 0) ? (session.previousWeeksPoints | number:'1.0-0') : "0" }}</td>
              <td>{{ session.currentLevel }}</td>
              <td>{{ session.currentWeekLevelsCompleted }}</td>
              <td>
                <wf-color-category [level]="session.previousWeekLevelsCompleted | previousWeekLevelCategory">
                  {{ session.previousWeekLevelsCompleted }}
                </wf-color-category>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
